export default "__VITE_ASSET__CFuoblrS__"